'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createHiddenThreeDSMethodDataInput = exports.createHiddenForm = exports.createHiddenIframe = undefined;

var _constants = require('./constants');

var _utils = require('../utils');

/**
 * Creates hidden iframe. Returns iframe element
 * @returns {iframe}
 **/
var createHiddenIframe = exports.createHiddenIframe = function createHiddenIframe() {
  var hiddenIframe = document.createElement('iframe');
  hiddenIframe.setAttribute('id', '' + _constants.HIDDEN_IFRAME_3DSV2);
  hiddenIframe.setAttribute('name', '' + _constants.HIDDEN_IFRAME_3DSV2);
  hiddenIframe.hidden = true;

  return hiddenIframe;
};

/**
 * Creates hidden form. Returns form element
 * @param {string} threeDSRedirectionUrl - received from DoDeposit response
 * @returns {form}
 **/
var createHiddenForm = exports.createHiddenForm = function createHiddenForm(threeDSRedirectionUrl) {
  var hiddenForm = document.createElement('form');
  hiddenForm.setAttribute('id', '' + _constants.HIDDEN_FORM_3DSV2);
  hiddenForm.setAttribute('action', '' + threeDSRedirectionUrl);
  hiddenForm.setAttribute('method', 'POST');
  hiddenForm.setAttribute('target', '' + _constants.HIDDEN_IFRAME_3DSV2);

  return hiddenForm;
};

/**
 * Creates hidden threeDSMethodData input. Returns input element
 * @param {string} threeDSMethodData - received from DoDeposit response
 * @returns {input}
 **/
var createHiddenThreeDSMethodDataInput = exports.createHiddenThreeDSMethodDataInput = function createHiddenThreeDSMethodDataInput(threeDSMethodData) {
  var threeDSMethodDataInput = document.createElement('input');
  threeDSMethodDataInput.setAttribute('type', 'hidden');
  threeDSMethodDataInput.setAttribute('name', 'threeDSMethodData');
  threeDSMethodDataInput.setAttribute('value', '' + threeDSMethodData);

  return threeDSMethodDataInput;
};

/**
 * Starts the 3DSv2 proccess. Creates hidden iframe and posts 3DSv2 data
 * @param {string} threeDSMethodData - received from DoDeposit response
 * @param {string} threeDSRedirectionUrl - received from DoDeposit response
 * @returns {void}
 **/
var start3DSv2Process = function start3DSv2Process(threeDSMethodData, threeDSRedirectionUrl) {
  try {
    var notRemovedIframe = document.getElementById('' + _constants.HIDDEN_IFRAME_3DSV2);

    if (notRemovedIframe !== null) {
      notRemovedIframe.remove();
    }

    var hiddenIframe = createHiddenIframe();
    var hiddenForm = createHiddenForm(threeDSRedirectionUrl);
    // TODO: replace createHiddenThreeDSMethodDataInput with createInputWithValue function
    var threeDSMethodDataInput = createHiddenThreeDSMethodDataInput(threeDSMethodData);

    hiddenForm.appendChild(threeDSMethodDataInput);
    hiddenIframe.appendChild(hiddenForm);
    document.body.appendChild(hiddenIframe);

    hiddenForm.submit();
  } catch (e) {
    throw (0, _utils.uniformError)(e);
  }
};

exports.default = start3DSv2Process;